import { render, staticRenderFns } from "./ConfigureFee.vue?vue&type=template&id=64a97be7&"
import script from "./ConfigureFee.vue?vue&type=script&lang=js&"
export * from "./ConfigureFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports